module.exports = __webpack_public_path__ + "static/media/golf.9f1d80be.svg";